import CandidateTable from './candidateTable';

export default CandidateTable;
